var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.06 30.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M53.87,22.46A.91.91,0,0,0,52.68,22a.9.9,0,0,0-.48.44,10.14,10.14,0,0,1-8.86,5.17H38.61A11.36,11.36,0,0,0,27.25,38.91a12.09,12.09,0,0,0,.09,1.21c3.78-2.7,9.22-5,16.94-5a1,1,0,1,1,0,1.9c-14.86,0-21.16,9.11-22.56,12.54A1.9,1.9,0,0,0,25.23,51a15.38,15.38,0,0,1,4.25-5.35A11.34,11.34,0,0,0,39.82,50.2c9.28-.67,15.82-9,15.82-19.19A21.5,21.5,0,0,0,53.87,22.46Z",
    transform: "translate(-21.58 -21.88)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.020873e1a677a47480e1ba6b19da1caa.svg";
export { ForwardRef as ReactComponent };